import { Link } from "react-router-dom";

export default function SubmitCta() {
  return (
    <section className="w-full bg-background-50 pb-16 md:pb-24">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border border-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20amber%20desk%20lamp%20light%20spilling%20over%20dark%20table%20with%20scattered%20photo%20prints%20and%20audio%20cassette%2C%20moody%20investigative%20still%20life%2C%20crimson%20accents%2C%20cinematic%20shadows&width=1400&height=700&seq=chigua-cta-bg&orientation=landscape"
            alt="暖色台灯下桌面上散落的照片与录音带，象征线索整理"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/60" />
          <div className="relative px-6 py-12 md:px-14 md:py-16 max-w-2xl">
            <span className="text-xs tracking-widest uppercase text-accent-300">Contribute</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              手里有还没被收录的素材？
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              把原始链接和大致时间发给我们，会先做来源核对，再决定是否放进对应的证据合集。补充、纠错、要求更正，也都走这个入口。
            </p>
            <Link
              to="/about#submit"
              className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line" />
              提交线索 / 联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}